<button (click)="onClick($event)" [ngClass]="buttonClasses">
  <img [ngClass]="imgClasses" [src]="imgSrc" />
  <p [ngClass]="text === '' ? 'hidden' : txtClasses">{{ text }}</p>
</button>
